import * as React from 'react';
import TwoColRow from './TwoColRow';
const CorporateEngagementSummary = ({ value, i18n, formatDate }) => (React.createElement(React.Fragment, null,
    React.createElement(TwoColRow, { label: i18n('service.checkpoints.CorporateEngagement.amount.caption'), value: value.engagements.length }),
    React.createElement(TwoColRow, { label: i18n('common.verifiedwith'), value: `${i18n('readreport.informationsource.CorporateEngagement')} (${formatDate(value.verificationDate)})` })));
export default CorporateEngagementSummary;
